import React from "react";
import { observer } from "mobx-react";
import { Message } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

const NoDefaultCreditCardMessage = observer(({ t }) => (
  <Message warning>
    <Message.Header>{t("billingCentral:noDefaultCreditCard")}</Message.Header>
    <p>{t("billingCentral:reminderMessageForDefaultCreditCard")}</p>
  </Message>
));

export default withTranslation()(NoDefaultCreditCardMessage);
